export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7773.6f75c643.jpg";